import { render, staticRenderFns } from "./chatx.vue?vue&type=template&id=726839a9&scoped=true"
import script from "./chatx.ts?vue&type=script&lang=ts&external"
export * from "./chatx.ts?vue&type=script&lang=ts&external"
import style0 from "./chatx.scss?vue&type=style&index=0&id=726839a9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726839a9",
  null
  
)

export default component.exports